import { MultiValue } from 'react-select'

interface Option {
  value: string
  label: string
}

/** id_market de bodega Xerox (recoge en bodega) — ver useRecogeEnBodega */
export const EXPORT_ID_MARKET_XEROX = '95'

export interface ExportFiltrosType {
  states: MultiValue<Option>
  store_name: MultiValue<Option>
  payment_method: MultiValue<Option>
  destination: MultiValue<Option>
  transportadora: MultiValue<Option>
  dateRange: { start: string; end: string }
  filterIdMarketXerox: boolean
}

/**
 * Construye los query params para la API basado en los filtros
 */
export const buildQueryParams = (filtros: ExportFiltrosType, page: number = 1): URLSearchParams => {
  const queryParams = new URLSearchParams()
  queryParams.set('limit', '80')
  queryParams.set('page', page.toString())

  // Agregar filtros multi-select
  if (filtros.states.length > 0) {
    queryParams.set('states', filtros.states.map(item => item.value).join(','))
  }
  if (filtros.store_name.length > 0) {
    queryParams.set('stores', filtros.store_name.map(item => item.value).join(','))
  }
  if (filtros.payment_method.length > 0) {
    queryParams.set('paymentMethod', filtros.payment_method.map(item => item.value).join(','))
  }
  if (filtros.destination.length > 0) {
    queryParams.set('destino_pedido', filtros.destination.map(item => item.value).join(','))
  }
  if (filtros.transportadora.length > 0) {
    queryParams.set('transportadora', filtros.transportadora.map(item => item.value).join(','))
  }

  // Agregar rango de fechas
  if (filtros.dateRange.start && filtros.dateRange.end) {
    queryParams.set('startDate', filtros.dateRange.start)
    queryParams.set('endDate', filtros.dateRange.end)
  }

  if (filtros.filterIdMarketXerox) {
    queryParams.set('id_market', EXPORT_ID_MARKET_XEROX)
  }

  return queryParams
}

/**
 * Formatea la fecha para el nombre del archivo Excel
 */
export const formatDateForFileName = (): string => {
  const now = new Date()
  return now
    .toISOString()
    .replace(/T/, '_')
    .replace(/\..+/, '')
    .replace(/:/g, '-')
}

